import React from 'react';
import { KpiCard } from '../../../components/app2';
import { formatMxn } from '../../../utils/billingService';

/**
 * Métricas de facturación de toda la plataforma (rediseño jul-2026).
 * Mismos cuatro números de siempre, con las tarjetas-KPI del sistema.
 */
const MetricsCards = ({ metrics }) => {
  if (!metrics) return null;
  const totals = metrics.totals || {};
  const revenue = metrics.revenue || {};

  return (
    <div className="a2-grid-kpi">
      <KpiCard
        icon="trending_up"
        value={formatMxn(revenue.mrr)}
        label="MRR (ingreso mensual recurrente)"
        sub={`ARR: ${formatMxn(revenue.arr)}`}
      />
      <KpiCard
        icon="payments"
        value={formatMxn(revenue.paid_last_30d)}
        label="Pagado últimos 30 días"
        sub="Suma de facturas pagadas"
        tone="ok"
      />
      <KpiCard
        icon="check_circle"
        value={totals.active || 0}
        label="Suscripciones activas"
        sub={`Total: ${totals.total_subscriptions || 0}`}
        tone="ok"
      />
      <KpiCard
        icon="warning"
        value={totals.past_due || 0}
        label="Con problemas de pago"
        sub={`Canceladas: ${totals.canceled || 0}`}
        tone={totals.past_due > 0 ? 'warn' : 'brand'}
      />
    </div>
  );
};

export default MetricsCards;
